import React, { useEffect, useState, useReducer, useCallback } from 'react'
import { Routes, Route, Navigate, BrowserRouter } from 'react-router'
import { Analytics } from "@vercel/analytics/react"
import DataRooms from './components/DataRooms'
import DataRoom from './components/DataRoom'
import AccessDataRoom from './components/AccessDataRoom'
import UserRights from './components/UserRights'
import Redaction from './components/Redaction'
import Statistics from './components/Statistics'
import QA from './components/QA'
import Billing from './components/Billing'
import BillingDataRoom from './components/BillingDataRoom'
import BillingUser from './components/BillingUser'
import { ListDataRooms, GetSessionStatus } from './modules/Rest'
import { DataRoomsContext, MessageContext, StatusContext } from './components/Contexts'
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { createAdminTheme } from './modules/Theme'
import { Reducer } from './components/MessageService'
import { DRIframe } from './components/DRIframe'
import { RoomRefresher } from './components/RoomRefresher'

const defaultTheme = createTheme()

function App() {
  const [dataRooms, setDataRooms] = useState([])
  const [dataRoomsLoading, setDataRoomsLoading] = useState(false)
  const [refreshNext, setRefreshNext] = useState(false)
  const [notificationBarOpen, setNotificationBarOpen] = useState(false)
  const [sessionStatus, setSessionStatus] = useState({})
  const [messageState, messageDispatch] = useReducer(Reducer, {operations: []})
  const [showAccessIframe, setShowAccessIframe] = useState(false)
  const [iframeRoom, setIframeRoom] = useState(false)

  const triggerRefresh = useCallback(async () => {
    setRefreshNext(false)
    setDataRooms([])
    try {
      await ListDataRooms({setDataRooms, setLoading: setDataRoomsLoading})
    } catch (error) {
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [])

  useEffect(() => {
    triggerRefresh()
  }, [triggerRefresh])


  useEffect(() => {
    async function getStatus() {
      try {
        const { data } = await GetSessionStatus()
        setSessionStatus(data)
      } catch (error) {
        messageDispatch({ type: 'warning', payload: error.message })
      }
    }
    getStatus()
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_APP_NAME)
      document.title = `Administration Interface | ${process.env.REACT_APP_APP_NAME}`;
  }, [])


  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={defaultTheme}>
        <ThemeProvider theme={createAdminTheme}>
          <MessageContext.Provider value={{messageState, messageDispatch, notificationBarOpen, setNotificationBarOpen}}>
            <DataRoomsContext.Provider value={{dataRooms, refreshNext, loading: dataRoomsLoading, setRefreshNext, triggerRefresh}}>
              <StatusContext.Provider value={{sessionStatus}}>
                <BrowserRouter basename="/newadmin">
                  <RoomRefresher refreshNext={refreshNext} triggerRefresh={triggerRefresh} >
                    <Routes>
                      <Route path="data-rooms">
                        <Route path=":dataRoomKey?" element={<DataRooms/>} />
                      </Route>
                      <Route path="data-room">
                        <Route path=":dataRoomKey?" element={<DataRoom />} />
                      </Route>
                      <Route path="user-rights">
                        <Route path=":dataRoomKey?" element={<UserRights />} />
                        <Route path=":dataRoomKey?/:userTypeKey?" element={<UserRights />} />
                      </Route>
                      <Route path="redaction">
                        <Route path=":dataRoomKey?" element={<Redaction />} />
                      </Route>
                      <Route path="qa">
                        <Route path=":dataRoomKey?/:qBranchId?/:categoryKey?" element={<QA />} />
                        <Route path=":dataRoomKey?/:qBranchId?" element={<QA />} />
                        <Route path=":dataRoomKey?" element={<QA />} />
                      </Route>
                      <Route path="statistics">
                        <Route path=":dataRoomKey?" element={<Statistics />} />
                      </Route>
                      <Route path="access">
                        <Route path=":dataRoomKey?" element={<AccessDataRoom setShowAccessIframe={setShowAccessIframe} setIframeRoom={setIframeRoom} /> } />
                      </Route>
                      <Route path="billing">
                        <Route path=":billingId?" element={<Billing />} />
                      </Route>
                      <Route path="billing-data-room">
                        <Route path=":dataRoomKey?" element={<BillingDataRoom />} />
                      </Route>
                      <Route path="billing-user">
                        <Route path=":userName?" element={<BillingUser />} />
                      </Route>
                      <Route
                        path="*"
                        element={<Navigate to="/data-rooms" replace/>}
                      />
                    </Routes>
                  </RoomRefresher>
                </BrowserRouter>
              </StatusContext.Provider>
            </DataRoomsContext.Provider>
          </MessageContext.Provider>
          <DRIframe showIframe={showAccessIframe} iframeRoom={iframeRoom} />
          <Analytics />
        </ThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App
